import { useLocation } from "react-router-dom";
import { RouteInformation } from "../routes.config";

const defaultTitle = process.env.REACT_APP_SITE_TITLE || "";
const envPrefix = process.env.REACT_APP_ENVIRONMENT !== "PRD" ? `**${process.env.REACT_APP_ENVIRONMENT}** - ` : "";
const titlePrefix = "Claims";

const createDocumentTitle = (route: RouteInformation) => {
  let documentTitle = "";
  if (route.claimType === "Motor") {
    documentTitle = `${envPrefix}${titlePrefix} - ${route.claimType ? `${route.claimType} -` : ""} ${route.subheading}`;
  } else {
    documentTitle = `${envPrefix}${titlePrefix} - ${route.claimType ? `${route.claimType} -` : ""} ${route.name}`;
  }
  return documentTitle;
};

const useDocumentTitle = (allRoutes: RouteInformation[]) => {
  const location = useLocation();
  const route = allRoutes.find((item) => item.path === location.pathname);
  const documentTitle = route?.name ? createDocumentTitle(route) : defaultTitle;

  return documentTitle;
};

export default useDocumentTitle;
